import { bindActionCreators } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IfIrr, IfOther, IfOverview, IfFundTerms, IfPrivateEquityCharacteristics, IfInvestmentLimits, IfPrivateEquityExtraInfo, defaultIfPrivateEquityExtraInfo, FileSrc } from "../../AssetContext";
import { actionCreators } from "../../state";
import LabelAndInput from "../LabelAndInput";
import { TitleColor1 } from "../typography/Typogtaphy";
import { sanitizeInputField } from "../../utils"
import ExtraInfoFileUpload, { UploadUtils } from "./utils/ExtraInfoFileUpload";

export default function ExtraInfoPrivateEquityForm(props: {
    assetInfo: any, setUpdateFun: any, media: any,
    uploadUtils: UploadUtils
}): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    // Asset ExtraInfo fields
    const [assetName, setAssetName] = useState<string>("")
    //irr
    const [targetMoic, setTargetMoic] = useState<string>("")
    const [targetGrossIrr, setTargetGrossIrr] = useState<string>("")
    //const[targetCashYield, setTargetCashYield] = useState<string>("")
    const [distributionPolicy, setDistributionPolicy] = useState<string>("")
    //other
    const [ifm, setIfm] = useState<string>("")
    const [auditor, setAuditor] = useState<string>("")
    const [custodian, setCustodian] = useState<string>("")
    const [reporting, setReporting] = useState<string>("")
    const [distributor, setDistributor] = useState<string>("")
    const [gpClawback, setGpClawback] = useState<string>("")
    const [hurdleRate, setHurdleRate] = useState<string>("")
    const [administrator, setAdministrator] = useState<string>("")
    const [navFrequency, setNavFrequency] = useState<string>("")
    const [shareClasses, setShareClasses] = useState<string>("")
    const [incentiveFees, setIncentiveFees] = useState<string>("")
    const [generalPartner, setGeneralPartner] = useState<string>("")
    const [legalCounselor, setLegalCounselor] = useState<string>("")
    const [legalStructure, setLegalStructure] = useState<string>("")
    const [managementFees, setManagementFees] = useState<string>("")
    const [subDistributor, setSubDistributor] = useState<string>("")
    const [portfolioManager, setPortfolioManager] = useState<string>("")
    const [typeOfWaterfall, setTypeOfWaterfall] = useState<string>("")
    const [subsequentSubscriptions, setSubsequentSubscriptions] = useState<string>("")
    //overview
    const [dealType, setDealType] = useState<string>("")
    const [fundName, setFundName] = useState<string>("")
    const [targetFundSize, setTargetFundSize] = useState<string>("")
    //const[overviewInvestmentPeriod, setOverviewInvestmentPeriod] = useState<string>("")
    const [riskReturnCharacteristics, setRiskReturnCharacteristics] = useState<string>("")
    const [targetAllocation, setTargetAllocation] = useState<string>("")
    const [investmentStrategyDescription, setInvestmentStrategyDescription] = useState<string>("")
    //fund terms
    const [rampUp, setRampUp] = useState<string>("")
    const [fundTerm, setFundTerm] = useState<string>("")
    const [finalClose, setFinalClose] = useState<string>("")
    const [firstClose, setFirstClose] = useState<string>("")
    const [capitalCalls, setCapitalCalls] = useState<string>("")
    const [fundTermsInvestmentPeriod, setFundTermsInvestmentPeriod] = useState<string>("")
    const [capitalRestitutions, setCapitalRestitutions] = useState<string>("")
    //characteristics
    const [warranty, setWarranty] = useState<string>("")
    const [coInvestment, setCoInvestment] = useState<string>("")
    const [dealCurrency, setDealCurrency] = useState<string>("")
    const [fundCurrency, setFundCurrency] = useState<string>("")
    const [targetSectors, setTargetSectors] = useState<string>("")
    const [targetDealSize, setTargetDealSize] = useState<string>("")
    const [numberOfDeals, setNumberOfDeals] = useState<string>("")
    const [primarySecondary, setPrimarySecondary] = useState<string>("")
    const [speedOfDeployment, setSpeedOfDeployment] = useState<string>("")
    const [targetCompanySize, setTargetCompanySize] = useState<string>("")
    const [portfolioCompanyProfile, setPortfolioCompanyProfile] = useState<string>("")
    const [typicalStakeInPortfolioCompanies, setTypicalStakeInPortfolioCompanies] = useState<string>("")
    //Investment restrictions
    const [leverage, setLeverage] = useState<string>("")
    const [derivatives, setDerivatives] = useState<string>("")
    const [geographicArea, setGeographicArea] = useState<string>("")
    const [maxIssuerLimit, setMaxIssuerLimit] = useState<string>("")
    const [maxSectorLimit, setMaxSectorLimit] = useState<string>("")
    const [esgConsiderations, setEsgConsiderations] = useState<string>("")
    const [excludedProfiles, setExcludedProfiles] = useState<string>("")
    const [maxCountryLimit, setMaxCountryLimit] = useState<string>("")
    const [interestCoverageRatio, setInterestCoverageRatio] = useState<string>("")

    const [images2, setImages2] = useState<FileSrc[]>([])
    const [videos, setVideos] = useState<FileSrc[]>([])
    const [documents, setDocuments] = useState<FileSrc[]>([])
    const [coownership, setCoownership] = useState<FileSrc[]>([])
    const [prospectus, setProspectus] = useState<FileSrc[]>([])

    const [isApprovedAndTokenized, setIsApprovedAndTokenized] = useState<boolean>(false)
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false)

    var newIrrInfo: IfIrr = {
        target_moic: sanitizeInputField(targetMoic),
        target_gross_irr: sanitizeInputField(targetGrossIrr),
        //target_cash_yield : targetCashYield,
        distribution_policy: (distributionPolicy)
    }

    var newOtherInfo: IfOther = {
        IFM: sanitizeInputField(ifm),
        auditor: sanitizeInputField(auditor),
        custodian: sanitizeInputField(custodian),
        reporting: (reporting),
        distributor: sanitizeInputField(distributor),
        gp_clawback: sanitizeInputField(gpClawback),
        hurdle_rate: sanitizeInputField(hurdleRate),
        administrator: sanitizeInputField(administrator),
        nav_frequency: sanitizeInputField(navFrequency),
        share_classes: sanitizeInputField(shareClasses),
        incentive_fees: sanitizeInputField(incentiveFees),
        general_partner: sanitizeInputField(generalPartner),
        legal_counselor: sanitizeInputField(legalCounselor),
        legal_structure: sanitizeInputField(legalStructure),
        management_fees: sanitizeInputField(managementFees),
        sub_distributor: sanitizeInputField(subDistributor),
        portfolio_manager: sanitizeInputField(portfolioManager),
        type_of_waterfall: sanitizeInputField(typeOfWaterfall),
        subsequent_subscriptions: (subsequentSubscriptions)
    }

    var newOverviewInfo: IfOverview = {
        deal_type: sanitizeInputField(dealType),
        fund_name: sanitizeInputField(fundName),
        target_fund_size: sanitizeInputField(targetFundSize),
        //investment_period : overviewInvestmentPeriod,
        risk_return_characteristics: (riskReturnCharacteristics),
        target_allocation: sanitizeInputField(targetAllocation),
        investment_strategy_description: (investmentStrategyDescription)
    }

    var newfund_termsrmsInfo: IfFundTerms = {
        ramp_up: sanitizeInputField(rampUp),
        fund_term: sanitizeInputField(fundTerm),
        final_close: sanitizeInputField(finalClose),
        first_close: sanitizeInputField(firstClose),
        capital_calls: sanitizeInputField(capitalCalls),
        investment_period: sanitizeInputField(fundTermsInvestmentPeriod),
        capital_restitutions: sanitizeInputField(capitalRestitutions)
    }

    var newCharacteristicsInfo: IfPrivateEquityCharacteristics = {
        warranty: warranty,
        co_investment: sanitizeInputField(coInvestment),
        deal_currency: sanitizeInputField(dealCurrency),
        fund_currency: sanitizeInputField(fundCurrency),
        target_sectors: (targetSectors),
        number_of_deals: sanitizeInputField(numberOfDeals),
        target_deal_size: sanitizeInputField(targetDealSize),
        primary_secondary: sanitizeInputField(primarySecondary),
        speed_of_deployment: sanitizeInputField(speedOfDeployment),
        target_company_size: (targetCompanySize),
        portfolio_company_profile: (portfolioCompanyProfile),
        typical_stake_in_portfolio_companies: sanitizeInputField(typicalStakeInPortfolioCompanies),

    }

    var newInvestmentLimitsInfo: IfInvestmentLimits = {
        leverage: sanitizeInputField(leverage),
        derivatives: sanitizeInputField(derivatives),
        geographic_area: sanitizeInputField(geographicArea),
        max_issuer_limit: sanitizeInputField(maxIssuerLimit),
        max_sector_limit: sanitizeInputField(maxSectorLimit),
        esg_considerations: (esgConsiderations),
        excluded_profiles: (excludedProfiles),
        max_country_limit: sanitizeInputField(maxCountryLimit),
        interest_coverage_ratio: sanitizeInputField(interestCoverageRatio)
    }

    var newPrivateEquityInfo: IfPrivateEquityExtraInfo = {
        irr: newIrrInfo,
        other: newOtherInfo,
        overview: newOverviewInfo,
        fund_terms: newfund_termsrmsInfo,
        characteristics: newCharacteristicsInfo,
        investment_limits: newInvestmentLimitsInfo
    }

    useEffect(() => {

        if (props.assetInfo.payload && props.assetInfo.payload.extra_info) {
            let ifPrivateEquity = defaultIfPrivateEquityExtraInfo
            if (props.assetInfo.payload.extra_info.private_equity) {
                ifPrivateEquity = props.assetInfo.payload.extra_info.private_equity.sub_assets ?
                    props.assetInfo.payload.extra_info.private_equity.sub_assets[0] :
                    defaultIfPrivateEquityExtraInfo
            }
            if (props.assetInfo.payload.asset_status_name !== "In Process" && props.assetInfo.payload.asset_status_name !== "Rejected")
                setIsApprovedAndTokenized(true)
            if (props.assetInfo.payload.asset_status_name === "Submitted")
                setIsSubmitted(true)

            setAssetName(props.assetInfo.payload.name)
            if (ifPrivateEquity) {

                setTargetMoic(ifPrivateEquity.irr.target_moic ? ifPrivateEquity.irr.target_moic : "")
                setTargetGrossIrr(ifPrivateEquity.irr.target_gross_irr)
                //setTargetCashYield(ifPrivateEquity.irr.target_cash_yield)
                setDistributionPolicy(ifPrivateEquity.irr.distribution_policy)

                setIfm(ifPrivateEquity.other.IFM)
                setAuditor(ifPrivateEquity.other.auditor)
                setCustodian(ifPrivateEquity.other.custodian)
                setReporting(ifPrivateEquity.other.reporting)
                setDistributor(ifPrivateEquity.other.distributor)
                setGpClawback(ifPrivateEquity.other.gp_clawback ? ifPrivateEquity.other.gp_clawback : "")
                setHurdleRate(ifPrivateEquity.other.hurdle_rate ? ifPrivateEquity.other.hurdle_rate : "")
                setAdministrator(ifPrivateEquity.other.administrator)
                setNavFrequency(ifPrivateEquity.other.nav_frequency)
                setShareClasses(ifPrivateEquity.other.share_classes)
                setIncentiveFees(ifPrivateEquity.other.incentive_fees)
                setGeneralPartner(ifPrivateEquity.other.general_partner ? ifPrivateEquity.other.general_partner : "")
                setLegalCounselor(ifPrivateEquity.other.legal_counselor ? ifPrivateEquity.other.legal_counselor : "")
                setLegalStructure(ifPrivateEquity.other.legal_structure ? ifPrivateEquity.other.legal_structure : "")
                setManagementFees(ifPrivateEquity.other.management_fees)
                setSubDistributor(ifPrivateEquity.other.sub_distributor)
                setPortfolioManager(ifPrivateEquity.other.portfolio_manager)
                setTypeOfWaterfall(ifPrivateEquity.other.type_of_waterfall ? ifPrivateEquity.other.type_of_waterfall : "")
                setSubsequentSubscriptions(ifPrivateEquity.other.subsequent_subscriptions)

                setDealType(ifPrivateEquity.overview.deal_type)
                setFundName(ifPrivateEquity.overview.fund_name)
                setTargetFundSize(ifPrivateEquity.overview.target_fund_size)
                //setOverviewInvestmentPeriod(ifPrivateEquity.overview.investment_period)
                setRiskReturnCharacteristics(ifPrivateEquity.overview.risk_return_characteristics)
                setTargetAllocation(ifPrivateEquity.overview.target_allocation)
                setInvestmentStrategyDescription(ifPrivateEquity.overview.investment_strategy_description ?
                    ifPrivateEquity.overview.investment_strategy_description : "")

                setRampUp(ifPrivateEquity.fund_terms.ramp_up)
                setFundTerm(ifPrivateEquity.fund_terms.fund_term)
                setFinalClose(ifPrivateEquity.fund_terms.final_close)
                setFirstClose(ifPrivateEquity.fund_terms.first_close)
                setCapitalCalls(ifPrivateEquity.fund_terms.capital_calls)
                setFundTermsInvestmentPeriod(ifPrivateEquity.fund_terms.investment_period)
                setCapitalRestitutions(ifPrivateEquity.fund_terms.capital_restitutions)

                setWarranty(ifPrivateEquity.characteristics.warranty)
                setCoInvestment(ifPrivateEquity.characteristics.co_investment)
                setDealCurrency(ifPrivateEquity.characteristics.deal_currency)
                setFundCurrency(ifPrivateEquity.characteristics.fund_currency)
                setTargetSectors(ifPrivateEquity.characteristics.target_sectors)
                setTargetDealSize(ifPrivateEquity.characteristics.target_deal_size)
                setNumberOfDeals(ifPrivateEquity.characteristics.number_of_deals)
                setPrimarySecondary(ifPrivateEquity.characteristics.primary_secondary)
                setSpeedOfDeployment(ifPrivateEquity.characteristics.speed_of_deployment)
                setTargetCompanySize(ifPrivateEquity.characteristics.target_company_size)
                setPortfolioCompanyProfile(ifPrivateEquity.characteristics.portfolio_company_profile)
                setTypicalStakeInPortfolioCompanies(ifPrivateEquity.characteristics.typical_stake_in_portfolio_companies)

                setLeverage(ifPrivateEquity.investment_limits.leverage)
                setDerivatives(ifPrivateEquity.investment_limits.derivatives)
                setGeographicArea(ifPrivateEquity.investment_limits.geographic_area)
                setMaxIssuerLimit(ifPrivateEquity.investment_limits.max_issuer_limit)
                setMaxSectorLimit(ifPrivateEquity.investment_limits.max_sector_limit)
                setEsgConsiderations(ifPrivateEquity.investment_limits.esg_considerations)
                setExcludedProfiles(ifPrivateEquity.investment_limits.excluded_profiles)
                setMaxCountryLimit(ifPrivateEquity.investment_limits.max_country_limit)
            }
        }
    }, [props.assetInfo.payload])

    function updateEI() {
        var subAsset: any[] = []
        subAsset.push(newPrivateEquityInfo)
        const assetExtraInfo = {
            private_equity: {
                sub_assets: subAsset
            }
        }
        return assetExtraInfo
    }

    useEffect(() => {
        props.setUpdateFun(updateEI)
    }, [assetName, targetMoic, targetGrossIrr, distributionPolicy, ifm, auditor, custodian, reporting, distributor,
        gpClawback, hurdleRate, administrator, navFrequency, shareClasses, incentiveFees, generalPartner, legalCounselor,
        legalStructure, managementFees, subDistributor, portfolioManager, typeOfWaterfall, subsequentSubscriptions, dealType,
        fundName, targetFundSize, riskReturnCharacteristics, targetAllocation, investmentStrategyDescription, rampUp, fundTerm,
        finalClose, firstClose, capitalCalls, fundTermsInvestmentPeriod, capitalRestitutions, warranty, coInvestment,
        dealCurrency, fundCurrency, targetSectors, targetDealSize, numberOfDeals, primarySecondary, speedOfDeployment,
        targetCompanySize, portfolioCompanyProfile, typicalStakeInPortfolioCompanies, leverage, derivatives, geographicArea,
        maxIssuerLimit, maxSectorLimit, esgConsiderations, excludedProfiles, maxCountryLimit])

    return <>
        <div className="grid md:px-20 px-5 grid-cols-12 mt-10" >
            <LabelAndInput label={"Asset Name"} value={assetName} fun={setAssetName} type={"disabled"} className={"col-span-12"} />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Overview</TitleColor1>

            <LabelAndInput id={"fundName"} label={"Fund Name *"} value={fundName} fun={setFundName} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"investmentStrategyDescription"} label={"Investment Strategy Description *"} value={investmentStrategyDescription} fun={setInvestmentStrategyDescription} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"dealType"} label={"Deal Type *"} value={dealType} fun={setDealType} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"targetAllocation"} label={"Target Allocation Seniority *"} value={targetAllocation} fun={setTargetAllocation} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"riskReturnCharacteristics"} label={"Main Risk and Return Characteristics *"} value={riskReturnCharacteristics} fun={setRiskReturnCharacteristics} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"targetFundSize"} label={"Target Fund Size *"} value={targetFundSize} fun={setTargetFundSize} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            {//<LabelAndInput label={"Investment Period *"} value={overviewInvestmentPeriod} fun={setOverviewInvestmentPeriod} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} />
            }

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Characteristics</TitleColor1>

            <LabelAndInput id={"portfolioCompanyProfile"} label={"Portfolio Company Profile *"} value={portfolioCompanyProfile} fun={setPortfolioCompanyProfile} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"primarySecondary"} label={"Primary Or Secondary *"} value={primarySecondary} fun={setPrimarySecondary} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"targetCompanySize"} label={"Target Company Size *"} value={targetCompanySize} fun={setTargetCompanySize} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"targetSectors"} label={"Target Sectors *"} value={targetSectors} fun={setTargetSectors} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"typicalStakeInPortfolioCompanies"} label={"Typical Stake In Portfolio Companies *"} value={typicalStakeInPortfolioCompanies} fun={setTypicalStakeInPortfolioCompanies} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"warranty"} label={"Warranty *"} value={warranty} fun={setWarranty} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"dealCurrency"} label={"Deal Currency *"} value={dealCurrency} fun={setDealCurrency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"fundCurrency"} label={"Fund Currency *"} value={fundCurrency} fun={setFundCurrency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"targetDealSize"} label={"Target Deal Size *"} value={targetDealSize} fun={setTargetDealSize} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"numberOfDeals"} label={"Number Of Deals *"} value={numberOfDeals} fun={setNumberOfDeals} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"coInvestment"} label={"Co Investment *"} value={coInvestment} fun={setCoInvestment} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"speedOfDeployment"} label={"Speed Of Deployment *"} value={speedOfDeployment} fun={setSpeedOfDeployment} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Investment Restrictions</TitleColor1>

            <LabelAndInput id={"geographicArea"} label={"Geographic Area *"} value={geographicArea} fun={setGeographicArea} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"maxCountryLimit"} label={"Max Country Limit *"} value={maxCountryLimit} fun={setMaxCountryLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxSectorLimit"} label={"Max Sector Limit *"} value={maxSectorLimit} fun={setMaxSectorLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxIssuerLimit"} label={"Max Portfolio Company Weight *"} value={maxIssuerLimit} fun={setMaxIssuerLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"excludedProfiles"} label={"Excluded Profiles *"} value={excludedProfiles} fun={setExcludedProfiles} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"esgConsiderations"} label={"ESG Consideration *"} value={esgConsiderations} fun={setEsgConsiderations} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"leverage"} label={"Leverage *"} value={leverage} fun={setLeverage} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"derivatives"} label={"Derivatives *"} value={derivatives} fun={setDerivatives} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ IRR</TitleColor1>

            <LabelAndInput id={"targetGrossIrr"} label={"Target Gross IRR *"} value={targetGrossIrr} fun={setTargetGrossIrr} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"targetMoic"} label={"Target Moic *"} value={targetMoic} fun={setTargetMoic} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            {//<LabelAndInput label={"Target Chash Yield *"} value={targetCashYield} fun={setTargetCashYield} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"}/>
            }
            <LabelAndInput id={"distributionPolicy"} label={"Distribution Policy *"} value={distributionPolicy} fun={setDistributionPolicy} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Fund Terms</TitleColor1>

            <LabelAndInput id={"firstClose"} label={"First Close *"} value={firstClose} fun={setFirstClose} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"finalClose"} label={"Final Close *"} value={finalClose} fun={setFinalClose} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"fundTerm"} label={"Fund Term *"} value={fundTerm} fun={setFundTerm} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"rampUp"} label={"Ramp Up *"} value={rampUp} fun={setRampUp} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"fundTermsInvestmentPeriod"} label={"Investment Period *"} value={fundTermsInvestmentPeriod} fun={setFundTermsInvestmentPeriod} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"capitalCalls"} label={"Capitals Calls *"} value={capitalCalls} fun={setCapitalCalls} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"capitalRestitutions"} label={"Capital Restitutions *"} value={capitalRestitutions} fun={setCapitalRestitutions} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Others</TitleColor1>

            <LabelAndInput id={"legalStructure"} label={"Legal Structure *"} value={legalStructure} fun={setLegalStructure} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"custodian"} label={"Custodian *"} value={custodian} fun={setCustodian} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"administrator"} label={"Administrator *"} value={administrator} fun={setAdministrator} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"auditor"} label={"Auditor *"} value={auditor} fun={setAuditor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"legalCounselor"} label={"Legal Counseler *"} value={legalCounselor} fun={setLegalCounselor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"generalPartner"} label={"General Partner *"} value={generalPartner} fun={setGeneralPartner} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"IFM"} label={"IFM *"} value={ifm} fun={setIfm} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"portfolioManager"} label={"Portfolio Manager *"} value={portfolioManager} fun={setPortfolioManager} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"managementFees"} label={"Management Fees *"} value={managementFees} fun={setManagementFees} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"incentiveFees"} label={"Incentive Fees *"} value={incentiveFees} fun={setIncentiveFees} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"hurdleRate"} label={"Hurdle Rate *"} value={hurdleRate} fun={setHurdleRate} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"typeOfWaterfall"} label={"Type Of Waterfall *"} value={typeOfWaterfall} fun={setTypeOfWaterfall} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"gpClawback"} label={"Gp Clawback *"} value={gpClawback} fun={setGpClawback} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"distributor"} label={"Distributor *"} value={distributor} fun={setDistributor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"subDistributor"} label={"Sub Distributor *"} value={subDistributor} fun={setSubDistributor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"shareClasses"} label={"Share Classes *"} value={shareClasses} fun={setShareClasses} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"subsequentSubscriptions"} label={"Subsequent Subscriptions *"} value={subsequentSubscriptions} fun={setSubsequentSubscriptions} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"navFrequency"} label={"Nav Frequency *"} value={navFrequency} fun={setNavFrequency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"reporting"} label={"Reporting *"} value={reporting} fun={setReporting} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />

            <ExtraInfoFileUpload assetName={props.assetInfo} isSubmitted={isSubmitted}
                coownership={coownership} setCoownership={setCoownership}
                prospectus={prospectus} setProspectus={setProspectus}
                images2={images2} setImages2={setImages2}
                documents={documents} setDocuments={setDocuments}
                uploadUtils={props.uploadUtils} media={props.media} />
        </div>
    </>
}